import { applyAuthHeaders } from 'store/slices/apiSlice';
import type { AuthState } from 'types';
import { getBaseUrl } from 'utils/baseUrl';

type RecordLockArgs = {
  agendaId: string;
  recordId: string;
  lockToken: string;
};

export const recordLockPath = (agendaId: string, recordId: string) => `/Agendas/${agendaId}/Records/${recordId}/Lock`;

export const releaseRecordLockKeepalive = (auth: AuthState, { agendaId, recordId, lockToken }: RecordLockArgs) => {
  const headers = applyAuthHeaders(new Headers(), auth);
  headers.set('X-Record-Lock-Token', lockToken);

  return fetch(getBaseUrl(`/api/Flow${recordLockPath(agendaId, recordId)}`), { method: 'DELETE', headers, keepalive: true });
};
